const c = {
  name: "BirthdayCake",
  dimensions: { width: 40, height: 39 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 39" style="enable-background:new 0 0 40 39;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M28,0c-0.7,0-1.2,0.5-1.5,0.8c-0.3,0.4-0.6,0.9-0.8,1.4C25.3,3.1,25,4.3,25,5c0,1.3,0.8,2.4,2,2.8V9h-2v6h-2
			V9h-2V7.8c1.2-0.4,2-1.5,2-2.8c0-0.7-0.3-1.9-0.7-2.8c-0.2-0.5-0.5-1-0.8-1.4C21.2,0.5,20.7,0,20,0s-1.2,0.5-1.5,0.8
			c-0.3,0.4-0.6,0.9-0.8,1.4C17.3,3.1,17,4.3,17,5c0,1.3,0.8,2.4,2,2.8V9h-2v6h-2V9h-2V7.8c1.2-0.4,2-1.5,2-2.8
			c0-0.7-0.3-1.9-0.7-2.8c-0.2-0.5-0.5-1-0.8-1.4C13.2,0.5,12.7,0,12,0s-1.2,0.5-1.5,0.8c-0.3,0.4-0.6,0.9-0.8,1.4
			C9.3,3.1,9,4.3,9,5c0,1.3,0.8,2.4,2,2.8V9H9v6H4v22H0v2h40v-2h-4V15h-5V9h-2V7.8c1.2-0.4,2-1.5,2-2.8c0-0.7-0.3-1.9-0.7-2.8
			c-0.2-0.5-0.5-1-0.8-1.4C29.2,0.5,28.7,0,28,0z M27,5c0-0.4,0.2-1.2,0.5-2c0.2-0.4,0.3-0.7,0.5-0.9l0,0l0,0
			c0.2,0.2,0.3,0.5,0.5,0.9C28.8,3.8,29,4.6,29,5c0,0.5-0.5,1-1,1S27,5.5,27,5z M28.1,2C28.1,2,28.1,2,28.1,2C28.1,2,28.1,2,28.1,2
			L28.1,2z M11,11h2v4h-2V11z M6,17h28v3.2c-0.5,0.2-0.9,0.4-1.2,0.7c-0.5,0.5-0.9,1.1-1.1,1.5l0,0c-0.3,0.5-0.6,0.9-0.9,1.2
			C30.5,23.9,30.3,24,30,24s-0.5-0.1-0.8-0.3c-0.3-0.3-0.5-0.7-0.9-1.2l0,0c-0.3-0.5-0.7-1.1-1.1-1.5C26.6,20.4,25.9,20,25,20
			s-1.6,0.4-2.2,0.9c-0.5,0.5-0.9,1.1-1.1,1.5l0,0c-0.3,0.5-0.6,0.9-0.9,1.2C20.5,23.9,20.3,24,20,24s-0.5-0.1-0.8-0.3
			c-0.3-0.3-0.5-0.7-0.9-1.2l0,0c-0.3-0.5-0.7-1.1-1.1-1.5C16.6,20.4,15.9,20,15,20s-1.6,0.4-2.2,0.9c-0.5,0.5-0.9,1.1-1.1,1.5l0,0
			c-0.3,0.5-0.6,0.9-0.9,1.2C10.5,23.9,10.3,24,10,24c-0.3,0-0.5-0.1-0.8-0.3c-0.3-0.3-0.5-0.7-0.9-1.2l0,0C8,22,7.7,21.4,7.2,20.9
			c-0.3-0.3-0.7-0.6-1.2-0.7V17z M21,11v4h-2v-4H21z M29,15h-2v-4h2V15z M34,33H6v-2h28V33z M34,35v2H6v-2H34z M34,22.6V29H6v-6.4
			c0.2,0.2,0.4,0.6,0.7,1l0,0C7,24,7.3,24.6,7.8,25.1C8.4,25.6,9.1,26,10,26c0.9,0,1.6-0.4,2.2-0.9c0.5-0.5,0.9-1.1,1.1-1.5l0,0
			c0.3-0.5,0.6-0.9,0.9-1.2c0.2-0.2,0.5-0.3,0.8-0.3s0.5,0.1,0.8,0.3c0.3,0.3,0.5,0.7,0.9,1.2l0,0c0.3,0.5,0.7,1.1,1.1,1.5
			c0.5,0.5,1.2,0.9,2.2,0.9s1.6-0.4,2.2-0.9c0.5-0.5,0.9-1.1,1.1-1.5l0,0c0.3-0.5,0.6-0.9,0.9-1.2c0.2-0.2,0.5-0.3,0.8-0.3
			s0.5,0.1,0.8,0.3c0.3,0.3,0.5,0.7,0.9,1.2l0,0c0.3,0.5,0.7,1.1,1.1,1.5c0.5,0.5,1.2,0.9,2.2,0.9s1.6-0.4,2.2-0.9
			c0.5-0.5,0.9-1.1,1.1-1.5l0,0C33.6,23.1,33.8,22.8,34,22.6z M19.5,3c0.2-0.4,0.3-0.7,0.5-0.9l0,0l0,0c0.2,0.2,0.3,0.5,0.5,0.9
			C20.8,3.8,21,4.6,21,5c0,0.5-0.5,1-1,1s-1-0.5-1-1C19,4.6,19.2,3.8,19.5,3z M11,5c0-0.4,0.2-1.2,0.5-2c0.2-0.4,0.3-0.7,0.5-0.9
			l0,0l0,0c0.2,0.2,0.3,0.5,0.5,0.9C12.8,3.8,13,4.6,13,5c0,0.5-0.5,1-1,1S11,5.5,11,5z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as BirthdayCake
};
